// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names, babel/camelcase */
import Price from "@kiwicom/frontend-common/records/Price"

import mmbTrack from "../../../../../../../services/tracking/mmbTrack"
import {
  GeneralModule,
  ServicePackageModule,
  ServicePackageRulesetReceiveAction,
  UnexpectedServerResponseAction,
} from "../../../../../../../services/tracking/constants/trackingEvents"
import type { ServicePackageRuleSetInbound } from "./servicePackageApiTypes"
import type { ServicePackage } from "./servicePackageTypes"
import { SERVICE_PACKAGES } from "../consts"

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line no-undef
function mapServicePackageLevel(level: ServicePackageLevel) {
  if (
    level === SERVICE_PACKAGES.BASIC ||
    level === SERVICE_PACKAGES.PLUS ||
    level === SERVICE_PACKAGES.PREMIUM
  ) {
    return level
  }

  mmbTrack(
    { module: GeneralModule, action: UnexpectedServerResponseAction },
    {
      api: "/mmb/v1/bookings/{booking_id}/service_package_rules",
      value: { level },
    },
  )

  return SERVICE_PACKAGES.BASIC
}

const ZERO_AMOUNT = "0"
export default function ({
  rules,
  level,
  reference_handling_fee,
  handling_fee,
}: ServicePackageRuleSetInbound): ServicePackage {
  const isLegacy = rules.category === "legacy"
  mmbTrack(
    {
      module: ServicePackageModule,
      action: ServicePackageRulesetReceiveAction,
    },
    {
      legacyServicePackage: isLegacy,
    },
  )
  const handlingFeeAmount = handling_fee.amount || ZERO_AMOUNT
  const savingPriceAmount =
    String(Number(reference_handling_fee.amount) - Number(handling_fee.amount)) || ZERO_AMOUNT
  const handlingFeeCurrency = handling_fee.currency || "EUR"
  return {
    level: mapServicePackageLevel(level),
    isLegacy,
    rules: {
      handlingFeePrice: Price.fromServer({
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        amount: rules.handling_fee || "0",
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        base: rules.handling_fee || "0",
        service_flat: "0",
        service: "0",
        merchant: "0",
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        currency: rules.currency || "EUR",
      }),
      // TOOD also returned from BE, but currently not needed:

      csAvailability: rules.cs_availability,
      callerPriority: rules.caller_priority,
      emailSupport: rules.email_support === "true",
    },
    handlingFeePrice: Price.fromServer({
      amount: handlingFeeAmount,
      base: handlingFeeAmount,
      service_flat: "0",
      service: "0",
      merchant: "0",
      currency: handlingFeeCurrency,
    }),
    savingPrice: Price.fromServer({
      amount: savingPriceAmount,
      base: savingPriceAmount,
      service_flat: "0",
      service: "0",
      merchant: "0",
      currency: handlingFeeCurrency,
    }),
    // rulesetId: res.ruleset_id
  }
}
